import React, { Suspense, Component } from "react";
import "./App.css";
import Layout from "./components/Layout/Layout";
import { connect } from "react-redux";
import * as AuthAction from "./store/auth/actions";
import { Route, BrowserRouter, Switch, Redirect } from "react-router-dom";
import Radium, { StyleRoot } from "radium";
import Loading from "./components/UI/Loading/Loading";
import { SnackbarProvider } from "notistack";

const Landing = React.lazy(() => import("./containers/landing/landing"));
const Checkout = React.lazy(() => import("./containers/checkout/checkout"));
const Account = React.lazy(() => import("./containers/account/account"));
const Store = React.lazy(() => import("./containers/store"));
const Download = React.lazy(() => import("./containers/download"));
const DirectDownload = React.lazy(() => import("./containers/direct-download"));
const CheckoutDone = React.lazy(() => import("./containers/checkout-done"));
class App extends Component {
  state = {
    match: {},
  };
  constructor(props) {
    super(props);
    props.autoLogin("match is");
  }

  render() {
    const token = localStorage.getItem("token");
    if (token && token.length > 8) {
      this.props.setIsAuth(true);
    } else {
      this.props.setIsAuth(false);
    }
    let routes = "";
    let checkoutDone = (
      <Route
        exact
        path={"/checkout-done/:transaction_id/:status/:mobile"}
        render={() => (
          <Suspense fallback={<Loading />}>
            <CheckoutDone route={(match) => this.setState({ match })} />
          </Suspense>
        )}
      />
    );
    let landing = (
      <Route
        exact
        path={"/"}
        render={() => (
          <Suspense fallback={<Loading />}>
            <Landing route={(match) => this.setState({ match })} />
          </Suspense>
        )}
      />
    );
    let checkout = (
      <Route
        exact
        path={"/checkout/:store_name/:store_id/"}
        render={() => (
          <Suspense fallback={<Loading />}>
            <Checkout route={(match) => this.setState({ match })} />
          </Suspense>
        )}
      />
    );
    let store = (
      <Route
        path={"/store/:store_name/:store_id"}
        render={() => (
          <Suspense fallback={<Loading />}>
            <Store route={(match) => this.setState({ match })} />
          </Suspense>
        )}
      />
    );
    let account = (
      <Route
        path={"/account"}
        render={() => (
          <Suspense fallback={<Loading />}>
            <Account route={(match) => this.setState({ match })} />
          </Suspense>
        )}
      />
    );
    let download = (
      <Route
        exact
        path={"/download"}
        render={() => (
          <Suspense fallback={<Loading />}>
            <Download route={(match) => this.setState({ match })} />
          </Suspense>
        )}
      />
    );
    let directDownload = (
      <Route
        exact
        path={"/directdownload"}
        render={() => (
          <Suspense fallback={<Loading />}>
            <DirectDownload route={(match) => this.setState({ match })} />
          </Suspense>
        )}
      />
    );
    // if Authentication
    if (this.props.is_auth) {
      routes = (
        <Switch>
          {checkoutDone}
          {landing}
          {checkout}
          {store}
          {account}
          {download}
          {directDownload}
          <Redirect to="/" />
        </Switch>
      );
    } else {
      routes = (
        <Switch>
          {checkoutDone}
          {landing}
          {store}
          {download}
          {directDownload}
          <Redirect to="/" />
        </Switch>
      );
    }
    return (
      <StyleRoot>
        <SnackbarProvider maxSnack={3}>
          <div className="App">
            <BrowserRouter>
              <Layout route={this.state.match}>{routes}</Layout>
            </BrowserRouter>
          </div>
        </SnackbarProvider>
      </StyleRoot>
    );
  }
}

const setStore = (dispatch) => {
  return {
    setIsAuth: (res) => dispatch(AuthAction.setIsAuth(res)),
    autoLogin: (res) => dispatch(AuthAction.autoLogin(res)),
  };
};

const getStore = (state) => {
  return {
    is_auth: state.auth.is_auth,
    user: state.auth.user,
  };
};

export default connect(getStore, setStore)(Radium(App));
